/**
 * DesignBar.jsx — Carousel Composer slide design: style preset, format, gap,
 * border and fill, applied to every slide (panoramas stay full bleed).
 */

import { useEffect, useState } from 'react';
import { setDesign, setPreset, useCarousel } from '../../hooks/useCarouselStore';

// Keeps what you typed (an empty box mid-edit) while the store holds the clamped number.
function NumberField({ value, onValue, ...rest }) {
  const [raw, setRaw] = useState(String(value));
  useEffect(() => {
    setRaw((r) => ((+r || 0) === value ? r : String(value)));
  }, [value]);
  return (
    <input
      type="number"
      value={raw}
      onChange={(e) => { setRaw(e.target.value); onValue(e.target.value); }}
      {...rest}
    />
  );
}

export default function DesignBar() {
  const design = useCarousel((s) => s.design);

  return (
    <div className="designbar" id="cc-design-bar">
      <div className="ctl">
        <span className="lbl">Style</span>
        <select value={design.preset} onChange={(e) => setPreset(e.target.value)} aria-label="Style">
          <option value="seamless">Seamless</option>
          <option value="hairline">Hairline gap</option>
          <option value="open">Open gap</option>
          <option value="frame">White frame</option>
          <option value="mat">Dark mat</option>
          <option value="wide">Wide mat</option>
          <option value="custom">Custom</option>
        </select>
      </div>
      <div className="ctl">
        <span className="lbl">Format</span>
        <select value={design.fmt} onChange={(e) => setDesign({ fmt: e.target.value })} aria-label="Format">
          <option value="4:5">4:5 portrait · 1080×1350</option>
          <option value="1:1">1:1 square · 1080×1080</option>
          <option value="1.91:1">1.91:1 wide · 1080×566</option>
        </select>
      </div>
      <div className="ctl">
        <span className="lbl">Gap</span>
        <NumberField value={design.gap} onValue={(v) => setDesign({ gap: v })} min="0" max="200" step="2" aria-label="Gap" />
      </div>
      <div className="ctl">
        <span className="lbl">Border</span>
        <NumberField value={design.pad} onValue={(v) => setDesign({ pad: v })} min="0" max="200" step="2" aria-label="Border" />
      </div>
      <div className="ctl">
        <span className="lbl">Fill</span>
        <input type="color" value={design.bg} onChange={(e) => setDesign({ bg: e.target.value })} aria-label="Fill" />
      </div>
      <span className="lbl design-note">every slide · panoramas stay full bleed</span>
    </div>
  );
}
